import { useEffect } from "react"

import { MODALS } from "@/constants/modals"
import { queryClient, useMakeAllFeedbacksRead } from "@/queries/queries"
import { useStore } from "@/zustand/store"

import FeedbackChatContainer from "./FeedbackChatContainer"

export default function RoundsNotesModal() {
  const feedbackUpload = useStore(
    (state) => state.modalsStates[MODALS.enrolledRounds.notes]
  )

  const { isSuccess } = useMakeAllFeedbacksRead(
    feedbackUpload?.feedbacks?.[0]?.task_submission_id
  )
  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries({ queryKey: ["allFeedbacks"] })
    }
  }, [isSuccess])

  if (!feedbackUpload) return null

  return <FeedbackChatContainer data={feedbackUpload?.feedbacks} />
}
